import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Bu ichki ERP tizimi — PWA/offline rejim kerak emas. Eski service worker
// boshqa portdagi (localhost:8000) backend so'rovlarini cache mantig'iga
// tortib, tarmoq xatolariga sabab bo'lishi mumkin, shuning uchun uni
// ro'yxatdan o'chiramiz va foydalanuvchida avval o'rnatilgan bo'lsa,
// uni ham faol tozalaymiz.
serviceWorkerRegistration.unregister();

try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch(() => {});
  }
} catch {
  // no-op: serviceWorker API mavjud bo'lmagan brauzerlar uchun
}

try {
  if ('caches' in window) {
    caches.keys()
      .then((names) => Promise.all(names.map((name) => caches.delete(name))))
      .catch(() => {});
  }
} catch {
  // no-op: Cache API mavjud bo'lmagan brauzerlar uchun
}

reportWebVitals();
